import { create, v } from '@dojo/framework/core/vdom';
import { icache } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';
import { createNlsMiddleware, recommended } from '@holmescorp/lcc-state';
import { lccstate, userstate } from '@holmescorp/lcc-state';
import { status } from '../middleware/status';
import { includes, isEmpty } from 'lodash-es';
import { publish } from '@holmescorp/pub-sub';
import { Keys } from '@holmescorp/common';
import themeCss from '../css/praise.m.css';
const factory = create({
    icache,
    nls: createNlsMiddleware('ditabook'),
    theme,
    userstate,
    lccstate,
    status,
    recommended
}).properties();
export const Praise = factory(({ properties, middleware: { theme, nls, userstate, lccstate, recommended } }) => {
    const css = theme.classes(themeCss);
    const { placeHolder = 'Placeholder' } = properties();
    const { format, messages } = nls();
    const { dashboard_practice_type: practice_type = 'practice', praise: praiseObject = '[ditabook] praise' } = messages;
    const praise = praiseObject ? JSON.parse(praiseObject.replace(/[\r\n\s]+/gm, ' ')) : {};
    const r = recommended.tracked.recommended;
    let content = null;
    const { get, path } = userstate;
    const qp = get(path('quizPattern'));
    const get_tree = (practice_type) => {
        const quizstate = get(path(practice_type));
        switch (practice_type) {
            case 'practice':
                return quizstate;
            case 'posttest':
                return quizstate.tree;
        }
        return {};
    };
    const tree = get_tree(practice_type);
    const has_scores = () => {
        const roots = lccstate.get(lccstate.path('ditaroots'));
        return roots.some((k) => tree[k].data.percent > 0);
    };
    const isInProgress = () => {
        return r && r.length > 0 && r.some((v) => v.completed);
    };
    const completed = () => {
        return r && r.length > 0 ? r.map((v) => v.completed).filter(Boolean).length : 0;
    };
    const totaled = () => {
        return r ? r.length : 0;
    };
    const hasAssessment = recommended.hasAssessment();
    const noAssess = !hasAssessment;
    const allCompleted = recommended.allcomplete();
    const hasPosttest = has_scores();
    const inProgress = isInProgress() && !allCompleted;
    const complete = hasAssessment && allCompleted && hasPosttest;
    const practice = hasAssessment && allCompleted && !hasPosttest;
    const assessComplete = hasAssessment && !inProgress && !practice && !complete;
    if (isEmpty(praise)) {
        content = placeHolder ? (typeof placeHolder === 'string' ? placeHolder : placeHolder[0]) : null;
    }
    else {
        const msgKey = noAssess
            ? 'noAssess'
            : assessComplete
                ? 'assessComplete'
                : inProgress
                    ? 'inProgress'
                    : practice
                        ? 'practice'
                        : complete
                            ? 'complete'
                            : null;
        const keysWithFormatting = praise.formattedKeys;
        const keyList = msgKey ? praise[msgKey] : [];
        const nlsKey = keyList ? keyList[Math.floor(Math.random() * keyList.length)] : '';
        const msg = nlsKey ? messages[nlsKey] : '';
        content =
            msg && nlsKey && msgKey
                ? v('div', { classes: [css.text] }, [
                    includes(keysWithFormatting, msgKey)
                        ? format(nlsKey, { complete: completed(), total: totaled() })
                        : msg
                ])
                : null;
    }
    const active = noAssess || practice;
    return v('div', {
        id: `dashboard-praise-${qp}`,
        role: active ? 'button' : null,
        tabIndex: active ? 0 : -1,
        classes: [theme.variant(), css.root, active ? css.button : null],
        onclick: (event) => {
            event.preventDefault();
            noAssess ? publish('site/assessment') : practice ? publish(`site/${practice_type}`) : null;
        },
        onkeydown: (event) => {
            switch (event.key) {
                case Keys.Enter:
                case Keys.Space:
                case Keys.Spacebar:
                    event.preventDefault();
                    noAssess ? publish('site/assessment') : practice ? publish(`site/${practice_type}`) : null;
            }
        }
    }, [content]);
});
export default Praise;
